import { type Language } from "~/api/tills/types";
import { AllergensLabeled } from "~/components/allergens";

import {
  BasketHeaderWrapper,
  type BasketHeaderWrapperProps
} from "../basket-header-wrapper";
import { BasketHeaderText } from "../basket-header-text";

import { HeaderBalance, type HeaderBalanceProps } from "./header-balance";
import {
  HeaderCollectLimit,
  type HeaderCollectLimitProps
} from "./header-collect-limit";

type BasketHeaderAuthProps = {
  username?: string | null;
  groupName?: string | null;
  allergens?: string[];
  language: Language;
  showUserBalanceAndDailySpendingLimit?: boolean;
} & Pick<BasketHeaderWrapperProps, "isEmpty"> &
  HeaderBalanceProps &
  HeaderCollectLimitProps;

export const BasketHeaderAuth = ({
  username,
  groupName,
  currency,
  locale,
  language,
  balance,
  collectLimit,
  allergens,
  isEmpty,
  showUserBalanceAndDailySpendingLimit = true
}: BasketHeaderAuthProps) => {
  return (
    <BasketHeaderWrapper isEmpty={isEmpty} isAuthenticated>
      <div className="flex flex-1 flex-col gap-2">
        <div className="inline-flex gap-1">
          <BasketHeaderText variant="primary">{username}</BasketHeaderText>
          <BasketHeaderText variant="secondary">{groupName}</BasketHeaderText>
        </div>

        {showUserBalanceAndDailySpendingLimit ? (
          <div className="inline-flex flex-wrap gap-3">
            <HeaderBalance
              balance={balance}
              currency={currency}
              locale={locale}
            />

            <HeaderCollectLimit
              collectLimit={collectLimit}
              currency={currency}
              locale={locale}
            />
          </div>
        ) : null}

        {allergens && allergens.length > 0 ? (
          <AllergensLabeled
            allergens={allergens}
            languageCode={language}
            allergenClassName="bg-interface-warning-1 font-normal text-xs"
          />
        ) : null}
      </div>
    </BasketHeaderWrapper>
  );
};
